import { WandSparkles } from "lucide-react";
import { cn } from "../../lib/cn";

export function LoadingState({ label = "読み込んでいます...", fullScreen = false }: { label?: string; fullScreen?: boolean }) {
  return (
    <div className={cn("flex items-center justify-center p-8", fullScreen && "min-h-screen")}>
      <div className="app-surface flex items-center gap-3 rounded-card px-4 py-3 shadow-soft">
        <WandSparkles className="h-5 w-5 animate-pulse text-[color:var(--primary)]" aria-hidden />
        <p className="text-sm font-medium text-[color:var(--muted)]">{label}</p>
      </div>
    </div>
  );
}
